<div
  class="tags-add"
  [class.is-active]="open"
  (keyup.escape)="onCloseDialog()"
  >
  <button
    type="button"
    class="rounded-md p-0.5 text-sky-500 border-sky-500 border-2"
    (click)="onToggle()"
    >
    @if (!open) {
      <svg class="w-5 h-5">
        <use xlink:href="assets/icons/symbols.svg#plus" ></use>
      </svg>
    } @else {
      <svg class="w-5 h-5">
        <use xlink:href="assets/icons/symbols.svg#minus"></use>
      </svg>
    }

  </button>

  <div class="dropdown" [class.is-hidden]="!open">
    <div class="dropdown__outer" (click)="onCloseDialog()"></div>

    <form class="dropdown__body" #addForm="ngForm" (ngSubmit)="onCreate()">
      <input
        type="text"
        class="control"
        [(ngModel)]="needle"
        name="tag"
        maxlength="30"
        required
        placeholder="Add tag"
        autocomplete="off"
        #inputElement
        >

      @if (addForm.invalid && (addForm.dirty || addForm.touched)) {
        <div class="text-md mt-1 text-red">
          Cannot create empty tag
        </div>
      }

      @if (tags().length) {
        <div class="tags-list">
          @for (tag of tags(); track tag) {
            <span
              class="tags-list__item"
              [style.--tag-color]="tagColorService.toColorHash(tag)"
              (click)="onSubmit(tag)"
            >{{ tag }}</span>
          }
        </div>
      }
    </form>

    @if (needle && !tags().includes(needle)) {
      <button
        type="button"
        class="dropdown__footer flex items-center justify-center w-full"
        (click)="onCreate()"
        >
        <svg class="w-5 h-5">
          <use xlink:href="assets/icons/symbols.svg#plus" ></use>
        </svg>
        Add new tag
      </button>
    }
  </div>
</div>
